import { Reveal } from "@/components/Reveal";
import { CalendarClock, ArrowRight } from "lucide-react";

const scrollToContact = (e) => {
  e.preventDefault();
  const el = document.querySelector("#contact");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function BookBrief() {
  return (
    <section
      id="book"
      data-testid="book-brief-section"
      className="relative border-y border-white/10 bg-[#080808] overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(90deg, #00FF66 0 1px, transparent 1px 60px)",
        }}
      />
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-14 lg:py-16 relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
        <Reveal className="lg:col-span-8">
          <div className="flex items-center gap-3 mb-4">
            <CalendarClock size={14} strokeWidth={1.5} className="text-[#00FF66]" />
            <span className="font-['JetBrains_Mono'] text-[11px] tracking-[0.3em] text-[#00FF66]">
              &gt;_ AVAILABILITY_WINDOW
            </span>
          </div>
          <h3
            data-testid="book-brief-title"
            className="font-['Unbounded'] font-bold text-2xl sm:text-3xl lg:text-[2.5rem] tracking-tight text-[#F5F5F5] leading-[1.05]"
          >
            Open to <span className="text-[#00FF66]">what's next</span>.
            <br />
            <span className="text-[#A1A1AA]">
              Roles, collaboration, or a coffee chat.
            </span>
          </h3>
          <p className="mt-4 max-w-2xl text-sm text-[#A1A1AA] leading-relaxed">
            Actively looking for IT / SOC / Security Analyst roles. Always open to
            collaboration on CTFs, home-lab builds, and study groups. If you're
            hiring, mentoring, or just want to trade notes — send a signal.
          </p>
        </Reveal>

        <Reveal className="lg:col-span-4 flex lg:justify-end" delay={0.15}>
          <a
            href="#contact"
            onClick={scrollToContact}
            data-testid="book-brief-cta"
            className="group inline-flex items-center gap-3 border border-[#00FF66] text-[#00FF66] px-6 py-4 font-['JetBrains_Mono'] text-[11px] tracking-[0.3em] hover:bg-[#00FF66] hover:text-black"
            style={{ transition: "background-color 0.15s, color 0.15s" }}
          >
            SAY HELLO
            <ArrowRight
              size={14}
              strokeWidth={1.5}
              className="group-hover:translate-x-1"
              style={{ transition: "transform 0.15s" }}
            />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
